import { render, staticRenderFns } from "./SelectExam.vue?vue&type=template&id=3ef64477"
import script from "./SelectExam.vue?vue&type=script&lang=js"
export * from "./SelectExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports